import React, {ReactNode} from 'react';
import {Navigate} from 'react-router-dom';
import {useAuth} from '../contexts/AuthContext';
import {UserRole} from '../../admin/users/types/User';

interface ProtectedRouteProps {
  children: ReactNode;
  allowedRoles?: UserRole[];
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({children, allowedRoles}) => {
  const {user, isAuthenticated, loading} = useAuth();

  if (loading) {
    return (
      <div>
        <div role="status">
          <span>Loading...</span>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (allowedRoles && user && !allowedRoles.includes(user.role)) {
    return <Navigate to="/home" replace/>;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
